import $ from 'jquery';
/* eslint-disable */
import slick from 'slick-carousel';
/* eslint-enable */
import settings from '../../../../scripts/settings-carousel';
/*
 * List of Dom Elements
 */
const elements = {
  $heroCarousel: $('.js-hero-slider'),
  $slides: $('.js-hero-slide'),
};

function init() {
  // Only activate slick if it the element exists & there is more than one slide
  if (elements.$heroCarousel && elements.$slides.length > 1) {
    elements.$heroCarousel.slick({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: 'c-hero__dots',
      autoplay: true,
      autoplaySpeed: 10000,
      prevArrow: settings.arrowPrev,
      nextArrow: settings.arrowNext,
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/entrade/hero/mando-ui.hero-carousel.js